import { useCallback } from "react";
import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana39Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandById = (id) => {
    return lands.filter((l) => l.id === id)[0];
  };
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };
  const getFill = useCallback(
    (id, selected2) => {
      const land = lands.find((l) => l.id === id);
      const disabledColor = "#6F8789";
      const normalColor = "#0096B3";
      const selectedColor = "#5AE5F4";

      if (!land) {
        return disabledColor; // disabled
      }

      if (selected) {
        if (id === selected.id) {
          return selectedColor;
        }
      }

      if (land.status !== "on_sale") {
        return disabledColor; // disabled
      } else {
        return normalColor; // normal color
      }
    },
    [lands, selected]
  );

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1468_42596)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M782.054 620.922L753.087 608.135L726.533 662.772H766.364C770.387 655.409 779.158 639.057 782.054 632.547C784.951 626.037 783.261 622.085 782.054 620.922Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M717.846 590.75L752.615 608.135L731.505 652.838L695.494 634.211L717.846 590.75Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        d="M637.127 662.774H726.533L731.5 652.84L661.962 616.829L637.127 662.774Z"
        fill={getFillByLot(18, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M681.83 573.365L717.841 590.75L695.49 634.211L660.721 616.827L681.83 573.365Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M647.061 555.982L681.83 573.367L660.72 616.828L624.709 599.444L647.061 555.982Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        d="M603.605 644.146L637.133 662.772L661.968 616.827L627.199 600.685L603.605 644.146Z"
        fill={getFillByLot(19, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("20"))}
        d="M567.59 625.52L603.601 644.146L627.194 600.685L591.183 582.059L567.59 625.52Z"
        fill={getFillByLot(20, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M612.293 538.598L647.062 555.982L624.71 599.444L589.941 580.817L612.293 538.598Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("21"))}
        d="M532.82 606.895L567.589 625.521L591.183 582.06L556.414 563.434L532.82 606.895Z"
        fill={getFillByLot(21, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M577.52 519.97L612.289 538.596L589.937 580.816L555.168 562.189L577.52 519.97Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M542.758 501.345L577.527 519.971L555.175 562.191L520.406 543.564L542.758 501.345Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        d="M496.812 587.026L532.823 606.894L556.417 563.432L521.648 543.564L496.812 587.026Z"
        fill={getFillByLot(22, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M509.222 482.72L542.75 501.346L520.398 543.566L485.629 524.939L509.222 482.72Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("23"))}
        d="M462.039 568.399L496.808 587.026L520.401 543.564L486.874 526.18L462.039 568.399Z"
        fill={getFillByLot(23, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("24"))}
        d="M426.031 548.532L462.042 568.4L486.877 526.181L450.866 506.312L426.031 548.532Z"
        fill={getFillByLot(24, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M474.457 462.851L509.226 482.719L485.632 524.938L450.863 506.312L474.457 462.851Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("25"))}
        d="M391.26 528.665L426.029 548.533L450.864 506.313L416.095 486.445L391.26 528.665Z"
        fill={getFillByLot(25, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M439.689 444.223L474.458 462.849L450.865 506.31L416.096 486.442L439.689 444.223Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M406.161 424.356L439.689 444.224L416.095 486.444L381.326 465.334L406.161 424.356Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("26"))}
        d="M357.732 510.037L391.26 528.663L416.095 486.443L383.809 466.575L357.732 510.037Z"
        fill={getFillByLot(26, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("27"))}
        d="M320.48 488.927L357.733 510.037L382.568 466.576L347.799 445.466L320.48 488.927Z"
        fill={getFillByLot(27, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("28"))}
        d="M286.953 467.818L320.48 488.928L347.799 445.467L314.272 425.599L286.953 467.818Z"
        fill={getFillByLot(28, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M372.634 404.488L406.162 424.356L381.327 465.334L349.041 445.466L372.634 404.488Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M340.352 384.621L372.637 404.489L347.802 445.466L313.033 425.598L340.352 384.621Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M306.82 364.754L340.348 384.622L313.029 425.6L279.502 405.732L306.82 364.754Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("29"))}
        d="M253.426 446.706L286.953 467.816L313.03 425.597L279.503 405.729L253.426 446.706Z"
        fill={getFillByLot(29, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M273.296 343.642L306.823 364.752L279.504 405.73L247.219 384.62L273.296 343.642Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("30"))}
        d="M219.898 426.84L253.426 446.708L279.503 405.73L247.217 384.621L219.898 426.84Z"
        fill={getFillByLot(30, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M241.012 323.774L273.297 343.642L247.221 384.62L213.693 362.268L241.012 323.774Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("31"))}
        d="M183.887 403.246L219.898 426.84L247.216 384.62L212.447 361.027L183.887 403.246Z"
        fill={getFillByLot(31, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M217.411 307.631L241.004 323.774L213.686 362.269L181.4 342.401C186.781 334.536 198.537 317.317 202.51 311.357C206.484 305.396 214.1 306.39 217.411 307.631Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("32"))}
        d="M160.294 369.718L181.404 342.399L212.449 361.026L183.888 403.245C178.093 399.106 165.013 389.834 159.052 385.861C153.092 381.887 157.396 373.443 160.294 369.718Z"
        fill={getFillByLot(32, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1468_42596"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1468_42596"
            transform="matrix(0.00170327 0 0 0.00225808 -2.20578 -0.708694)"
          />
        </pattern>
        <image
          id="image0_1468_42596"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
